module.exports = __webpack_public_path__ + "img/profile-avatar.d9ee7636.svg";